import aqilaApi from './aqila-api';
import { Parametro } from '../@types';

class Parametros {
  private readonly endpoint = 'v1/parametros';

  async parametro() {
    const { data } = await aqilaApi.get<Parametro>(this.endpoint);

    return data.parametros;
  }
}

export default new Parametros();
